import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getRuntimeConfig } from "@/config/runtime";
import { useSession } from "@/hooks/useSession";

export function SessionGate({ children }: { children: ReactNode }) {
  const location = useLocation();
  const runtime = getRuntimeConfig();
  const { data: session, loading, error, reload } = useSession();

  const params = new URLSearchParams(location.search);
  if (runtime.mode === "demo" && params.get("lh") === "1") {
    return <>{children}</>;
  }

  if (loading) {
    return <div style={{ padding: 32 }}>Loading session…</div>;
  }

  if (error || !session) {
    return (
      <div style={{ padding: 32 }}>
        <p style={{ margin: "0 0 12px" }}>Unable to load your session.</p>
        <button type="button" onClick={reload}>Try again</button>
      </div>
    );
  }

  if (!session.authenticated) {
    const from = location.pathname + location.search + location.hash;
    if (runtime.usesPortalLoginPage) {
      return <Navigate to="/login" replace state={{ from }} />;
    }

    if (session.loginUrl) {
      window.location.assign(session.loginUrl);
      return <div style={{ padding: 32 }}>Redirecting to sign-in…</div>;
    }

    return <div style={{ padding: 32 }}>Sign-in is required.</div>;
  }

  return <>{children}</>;
}
